import request from '@/utils/request'

//订单列表
export function orderList(query) {
    return request({
        url: 'order/orderList',
        method: 'get',
        params: query
    })
}
//订单列表 导出
export function orderListExcel(query) {
    return request({
        url: 'order/orderListExcel',
        method: 'get',
        params: query
    })
}

//订单取消
export function cancelOrders(data) {
    return request({
        url: 'order/cancelOrders',
        method: 'post',
        data
    })
}

//订单发货
export function orderSend(query) {
    return request({
        url: 'order/orderSend',
        method: 'get',
        params: query
    })
}

//订单查看查看
export function orderView(query) {
    return request({
        url: 'order/orderView',
        method: 'get',
        params: query
    })
}

//查看单据地址
export function orderAddr(query) {
    return request({
        url: 'order/orderAddr',
        method: 'get',
        params: query
    })
}

//订单编辑地址
export function editAddrAndUIN(data) {
    return request({
        url: 'order/editAddrAndUIN',
        method: 'post',
        data
    })
}
